import React, { useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useAggregate } from 'hooks';
import { Context as AuthContext } from 'contexts/auth';
import { Config } from 'configs';
import { PageTitle } from 'components/layouts/pageTitle';
import { ListLayout } from 'components/layouts/listLayout';
import { QrCode } from 'components/blocks/qrCode';
import { TablesAddEditForm } from './_form';

export const TableDetails = () => {
  const { state: auth } = useContext(AuthContext);

  const qrRef = useRef(null);

  const params = useParams();
  const { id } = params;

  const requestData = {
    collectionName: Config.DATA.COLLECTIONS.TABLES,
    aggregateId: Config.DATA.AGGREGATES.GET_TABLE_BY_ID,
    secretKey: auth.token,
    filter: { company: auth.company?.company, tableId: id },
    aggregateIdV2: 'AdminGetTableDetails',
    companyIdForV2: auth.company?.company,
  };

  const [, tables, isLoading] = useAggregate(requestData);

  const table = tables && tables.length > 0 ? tables[0] : null;

  const isEditable = table && table.is_manual;

  return (
    <ListLayout isLoading={isLoading}>
      {!!table && (
      <>
        {isEditable && (
        <div className="mb-16">
          <TablesAddEditForm isEdit tableData={table} />
        </div>
        )}

        {!isEditable && (
        <PageTitle
          renderTitle={() => (
            <span>Table #{table.number}{' '}</span>
          )}
          breadcrumbs={[
            { path: '/tables', title: 'Tables' },
          ]}
        />
        )}

        <div className="container mx-auto px-2 md:px-6 lg:px-8">
          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 sm:px-6 py-5 grid grid-cols-3 gap-4">
              <div className="col-span-3">
                <p className="mt-1 max-w-2xl text-sm text-gray-500">Restaurant: {table.restaurant_name || ''}</p>
              </div>
            </div>
            <div className="border-t border-gray-200">
              <dl>
                {!isEditable && (
                <>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Section</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{table.area_name || '-'}</dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Name</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {table.name || '-'}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Number</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {table.number || '-'}
                    </dd>
                  </div>
                </>
                )}
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    QR code
                    {!!table.url && (
                    <button
                      type="button"
                      className="text-indigo-600 hover:text-indigo-900 block"
                      onClick={() => qrRef.current.download()}
                    >
                      Download
                    </button>
                    )}
                  </dt>
                  {!!table.url && (
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <QrCode
                      ref={qrRef}
                      data={`${table.url}?type=table&scanId=${table.qr}`}
                      downloadFileName={`table-${table.number}`}
                    />
                  </dd>
                  )}
                  {!table.url && <p className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">Client not setup by Waitless</p>}
                </div>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Link</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {!!table.url && (
                    <a
                      href={`${table.url}?type=table&scanId=${table.qr}`}
                      target="_blank"
                      className="text-indigo-600 hover:text-indigo-900"
                      rel="noreferrer"
                    >
                      Open table
                    </a>
                    )}
                    {!table.url && <p>Client not setup by Waitless</p>}
                  </dd>
                </div>
                {!!table.qr && (
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Code</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {table.qr}
                  </dd>
                </div>
                )}
              </dl>
            </div>
          </div>

        </div>
      </>
      )}
    </ListLayout>
  );
};
